export default __webpack_public_path__ + "static/media/synthesizer.41ad3bf6.svg";